export default __webpack_public_path__ + "static/media/recorte_26.dd841a04.jpg";